import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule, Routes} from '@angular/router';

import {NotfoundPageComponent} from './notfound-page.component';

const routes: Routes = [
  {path: '', component: NotfoundPageComponent}
];
@NgModule({
  declarations: [NotfoundPageComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule]
})
export class NotfoundPageModule { }
